/**
 * BitacoraFeed Component
 *
 * Social-media-mural view for the project bitácora. Routes each classified
 * feed item (date header, post, mini-post, collapsed group) to the matching
 * component. Data fetching and filters live upstream in ProjectTimeline.
 *
 * @module components/timeline/BitacoraFeed
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BitacoraPost from './BitacoraPost';
import BitacoraMiniPost from './BitacoraMiniPost';
import BitacoraCollapsedGroup from './BitacoraCollapsedGroup';
import { classifyAndGroupEvents } from '../../services/timelineService';
import './BitacoraFeed.css';

const BitacoraFeed = ({ events }) => {
  const items = useMemo(() => classifyAndGroupEvents(events), [events]);

  if (!items.length) return null;

  return (
    <div className="bitacora-feed">
      {items.map((item, idx) => {
        if (item.kind === 'date_header') {
          return (
            <div
              key={`date-${item.date}`}
              className="bitacora-feed-date-header"
            >
              {item.displayDate}
            </div>
          );
        }
        if (item.kind === 'post') {
          return (
            <BitacoraPost
              key={`post-${item.event.source}-${item.event.id}-${idx}`}
              event={item.event}
            />
          );
        }
        if (item.kind === 'mini') {
          return (
            <BitacoraMiniPost
              key={`mini-${item.event.source}-${item.event.id}-${idx}`}
              event={item.event}
            />
          );
        }
        if (item.kind === 'group') {
          return (
            <BitacoraCollapsedGroup
              key={`group-${item.user_id}-${item.date}-${idx}`}
              group={item}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

BitacoraFeed.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BitacoraFeed;
